module.exports = {
      id: "vikatantv-usage",
      viewBox: "0 0 25.176 25.204",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#vikatantv",
      toString: function () {
        return this.url;
      }
    }